import React from "react";
import "./sub-headline.m.css";

export default function SubHeadline({ subheadline }) {
  return subheadline ? <p styleName="sub-headline">{subheadline}</p> : null;
}
